import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService, StorageType } from '@rct/lynx-lobbies-shared-lib';
import { TranslateService } from '@ngx-translate/core';
import { LYNX_STORAGE_KEYS } from '../constants/lynx-storage-keys.constant';

@Injectable({
  providedIn: 'root',
})
export class LynxLocalizeRouterService {
  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private router: Router
  ) {}

  get currentLang() {
    return this.translate.currentLang;
  }

  get parser() {
    return {
      locales: this.translate.langs,
      currentLang: this.translate.currentLang,
      defaultLang: this.translate.defaultLang,
    };
  }

  translateRoute(url: string, useDefault: boolean = false): void {
    if (url.includes('auth')) {
      url = 'login';
    }

    url = this.loginPageRule(url);
    this.router.navigateByUrl(`/${url}`);
  }

  private loginPageRule(url: string) {
    const lobbyId = this.storageService.get(
      LYNX_STORAGE_KEYS.lobbyId,
      StorageType.Session
    );
    const isLoginPage = url.includes('login');
    if (lobbyId && isLoginPage) {
      url = `${url}?lobbyid=${lobbyId}`;
    }
    return url;
  }
}
